'use client';

/* 
  底部佇列與元件互動需要全域變數來溝通
  1. 點擊底部聊天需要直接打開聊天室
*/
import { type Dispatch, createContext, useState, type SetStateAction } from 'react';

type Store = {
  commentIsOpen: boolean;
};

type ContextProps = {
  store: Store;
  setStore: Dispatch<SetStateAction<Store>>;
};

export const BottomNavigatorContext = createContext<ContextProps | null>(null);

const BottomNavigatorProvider = ({ children }: { children: React.ReactNode }) => {
  const [store, setStore] = useState({} as Store);

  return <BottomNavigatorContext.Provider value={{ store, setStore }}>{children}</BottomNavigatorContext.Provider>;
};

export default BottomNavigatorProvider;
